/**
 * Route configuration for App.
 * This file defines how the relevant feature area is exposed through the Angular router.
 */
import { Routes } from '@angular/router';
import { canActivateAuth, canMatchByAccess } from './core/rbac/rbac-route.guard';
import { environment } from '../environments/environment';

const developmentRoutes: Routes = environment.showDevelopmentScreens
  ? [
      {
        path: 'component-screen',
        canMatch: [canMatchByAccess('componentScreen')],
        loadChildren: () => import('./features/components-screen/components-screen.routes').then((m) => m.componentsScreenRoutes)
      },
      {
        path: 'components-screen',
        redirectTo: 'component-screen',
        pathMatch: 'full'
      }
    ]
  : [];

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./features/forgot-password/forgot-password.routes').then((m) => m.forgotPasswordRoutes)
  },
  {
    path: '',
    canActivate: [canActivateAuth],
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        canMatch: [canMatchByAccess('dashboard')],
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'agencies',
        loadChildren: () => import('./features/agencies/agencies.routes').then((m) => m.agenciesRoutes)
      },
      {
        path: 'supervisors',
        loadChildren: () => import('./features/supervisors/supervisors.routes').then((m) => m.supervisorsRoutes)
      },
      {
        path: 'agents',
        loadChildren: () => import('./features/agents/agents.routes').then((m) => m.agentsRoutes)
      },
      {
        path: 'pos',
        loadChildren: () => import('./features/pos/pos.routes').then((m) => m.posRoutes)
      },
      {
        path: 'inventory',
        loadChildren: () => import('./features/inventory/inventory.routes').then((m) => m.inventoryRoutes)
      },
      {
        path: 'reports',
        canMatch: [canMatchByAccess('reports')],
        loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent)
      },
      {
        path: 'alerts',
        canMatch: [canMatchByAccess('alerts')],
        loadComponent: () => import('./features/alerts/alerts.component').then((m) => m.AlertsComponent)
      },
      {
        path: 'configurations',
        loadChildren: () => import('./features/configurations/configurations.routes').then((m) => m.configurationsRoutes)
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.routes').then((m) => m.rolesRoutes)
      },
      {
        path: 'roles/create',
        canMatch: [canMatchByAccess('rolesCreate')],
        loadComponent: () => import('./features/roles/roles-form.component').then((m) => m.RolesFormComponent)
      },
      {
        path: 'profile',
        canMatch: [canMatchByAccess('profile')],
        loadComponent: () => import('./features/profile/profile.component').then((m) => m.ProfileComponent)
      },
      {
        path: 'btl',
        loadChildren: () => import('./features/btl/btl.routes').then((m) => m.btlRoutes)
      },
      {
        path: 'logistics',
        loadChildren: () => import('./features/logistics/logistics.routes').then((m) => m.logisticsRoutes)
      },
      ...developmentRoutes
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
